'use es6';

import PropTypes from 'prop-types';
import { Component } from 'react';
import * as Atom from 'atom';
import get from 'transmute/get';
import I18n from 'I18n';
import { Metrics } from '../metrics/Metrics';
import { jsx as _jsx } from "react/jsx-runtime";
export const SaveBarContainer = (Wrapper, editableAreas) => {
  class SaveBar extends Component {
    constructor() {
      super();
      this.handleAreasChange = areas => {
        this.setState({
          areas
        });
        const hasChanges = areas.some(({
          changes
        }) => !!changes);
        if (hasChanges && !this.previousHasChanges) {
          this.previousHasChanges = true;
          Metrics.counter('universal-savebar-visible').increment();
        }
      };
      this.handleCancel = evt => {
        this.state.areas.forEach(({
          changes,
          onCancel
        }) => {
          if (changes) {
            onCancel(evt);
          }
        });
      };
      this.handleSave = evt => {
        this.state.areas.forEach(({
          changes,
          onSave
        }) => {
          if (changes) {
            onSave(evt);
          }
        });
      };
      this.state = {
        areas: Atom.deref(editableAreas)
      };
    }
    componentDidMount() {
      Atom.watch(editableAreas, this.handleAreasChange);
      this.previousHasChanges = false;
    }
    componentWillUnmount() {
      Atom.unwatch(editableAreas, this.handleAreasChange);
    }
    getWatchedAreasByKeyName(areaName) {
      const {
        areas
      } = this.state;
      return areas.toSeq().filter(get(areaName)).map(get(areaName)).toArray();
    }
    render() {
      const {
        areas
      } = this.state;
      const hasChanges = areas.some(({
        changes
      }) => !!changes);
      const hasErrors = areas.some(({
        errors
      }) => !!errors);
      const isLoading = areas.some(({
        loading
      }) => !!loading);
      if (!hasChanges && !this.props.alwaysShowSaveBar) {
        return null;
      }
      const formattedChanges = I18n.formatList([...this.getWatchedAreasByKeyName('changes'), ...this.getWatchedAreasByKeyName('errors'), ...this.getWatchedAreasByKeyName('warnings')]);
      return /*#__PURE__*/_jsx(Wrapper, Object.assign({}, this.props, {
        hasErrors: hasErrors,
        hasChanges: hasChanges,
        isLoading: isLoading,
        areas: areas,
        formattedChanges: formattedChanges,
        handleSave: this.handleSave,
        handleCancel: this.handleCancel
      }));
    }
  }
  SaveBar.defaultProps = {
    alwaysShowSaveBar: false
  };
  SaveBar.propTypes = {
    alwaysShowSaveBar: PropTypes.bool
  };
  return SaveBar;
};